import classNames from "classnames";
import DownloadTicket from "./DownloadTicket";
import Ticket from "./Ticket";
import TicketRegisterForm from "./TicketRegisterForm";
import { getTicketImageUrl } from "../../utils";
import config from "../../data/config";

export default function TicketConfirmation({
  id,
  ticketNo,
  githubAvatarUrl,
  githubUserName,
  githubName,
}) {
  const titleClass = classNames(
    "text-2xl md:text-5xl text-center md:text-left font-bold leading-tight"
  );
  const descClass = classNames(
    "text-xl md:text-2xl text-center md:text-left mt-4 mr-0 md:mr-20"
  );
  const ticketUrl = getTicketImageUrl(githubUserName);
  const name = githubName || githubUserName;

  return (
    <div className="mx-auto max-w-screen-2xl block md:flex flex-row-reverse mt-10 md:mt-24 px-4 md:px-8">
      <div className="flex-1 mb-10">
        {/* <Ticket
          ticketNo={ticketNo}
          githubAvatarUrl={githubAvatarUrl}
          githubName={githubName}
          githubUserName={githubUserName}
        /> */}
        <img src={ticketUrl} alt="ticket" />
        {/* <div className="flex flex-col md:flex-row justify-end">
          <DownloadTicket githubUserName={githubUserName} />
        </div> */}
      </div>
      {config.ENABLE_REGISTRATION && (
        <div className="flex-1 mb-10">
          <h1 className={titleClass}>
            {githubName === "Your Name" ? "" : `${name}'s`} Ticket
          </h1>
          <p className={descClass}>
            Register to join {githubName === "Your Name" ? "us" : name} at React
            Day Bangalore on June 8-9, 2022
          </p>
          <div className="mt-10 mr-0 md:mr-20">
            <TicketRegisterForm />
          </div>
        </div>
      )}
    </div>
  );
}
